<template>
    <modal class="w-full h-full" :partners="true" @close="$emit('close')">
        <div class="relative pb-12 md:pb-0">
            <button class="absolute pin-t pin-r outline-none m-5 z-40" @click="$emit('close')">
                <img class="" src="@/assets/SVG/cross-partners.svg"/>
            </button>
            <div class="px-8 pt-16">
                <div class="flex text-center justify-center">
                    <p class="text-main-text font-semibold whitespace-pre-line" v-text="text"></p>
                     <p class="text-main-text font-semibold whitespace-pre-line" v-html="html"></p>
                </div>
            </div>
            <div v-if="!reverseButtons" class="p-3  md:p-10 flex flex-col-reverse md:flex-row justify-center iphone-position" slot="footer">
                <button v-if="button_text_firs" @click="$emit('white_button')" class="inline-block justify-center w-full whitespace-no-wrap  hover-up font-bold bg-white  border border-main-text text-main-text rounded-full px-6 py-3 outline-none mt-2 md:mt-0">
                    <span v-text="button_text_firs"></span>
                </button>
                <button v-if="button_text_second" @click="$emit('yellow_button')" class="iphone-yellow outline-none md:ml-4 rounded-full  whitespace-no-wrap w-full hover-up flex flex-row items-center justify-center bg-brand-yellow  md:border-0  px-8 py-3 text-main-text">
                    <span class="mx-3 font-semibold" v-text="button_text_second"></span>
                </button>
            </div>
              <div v-else class="p-3  md:p-10 flex flex-col md:flex-row justify-center iphone-position" slot="footer">
                <button v-if="button_text_firs" @click="$emit('white_button')" class="inline-block justify-center w-full whitespace-no-wrap  hover-up font-bold bg-brand-yellow text-main-text rounded-full px-6 py-3 outline-none ">
                    <span v-text="button_text_firs"></span>
                </button>
                <button v-if="button_text_second" @click="$emit('yellow_button')" class="mt-2 md:mt-0 iphone-yellow border border-main-text  rounded-full  whitespace-no-wrap w-full hover-up flex flex-row items-center justify-center bg-white   border-main-text  px-8 py-3 text-main-text md:ml-4">
                    <span class="mx-3 font-semibold" v-text="button_text_second"></span>
                </button>
            </div>
        </div>
    </modal>

</template>
<script>
import ModalMixin from '../../../../mixins/modals';
import Modal from '@/views/modals/base-modal';


export default {
  name: 'DeleteModal',
  components: { Modal },
  props: ['text', 'button_text_firs', 'button_text_second', 'partners', 'html', 'reverseButtons'],

  mixins: [ModalMixin],
  data() {
    return {

    };
  },
};

</script>


<style scoped>
    @media only screen and (min-width: 319px) and (max-width: 330px) {
        .iphone-position {
            flex-direction: column !important;
        }
        .iphone-yellow {
            margin-left: 0 !important;
            margin-top: 1rem;
        }
    }
</style>

